// extracted by mini-css-extract-plugin
export var container = "Burger-module--container--18b20";